import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { modules } from '../data/productModules';

const ModuleGuide: React.FC = () => {
  useEffect(() => {
    document.title = 'Module Guide | Explanatum';
  }, []);

  return (
    <main className="min-h-screen bg-slate-50">
      <section className="relative overflow-hidden bg-gradient-to-br from-indigo-50 via-white to-sky-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <header className="text-center mb-14">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Explore the Explanatum module suite</h1>
            <p className="mt-4 text-lg text-slate-600">
              One place to discover every specialised AI workspace, including our consultants, planners, and creative tools.
            </p>
          </header>

          <div className="grid gap-8 md:grid-cols-2">
            {modules.map((module) => (
              <article
                key={module.title}
                className="rounded-3xl border border-indigo-100 bg-white p-6 shadow-lg transition hover:-translate-y-1 hover:shadow-xl"
              >
                <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3 py-1 text-xs font-semibold text-indigo-600">
                  Featured module
                </div>
                <h2 className="mt-4 text-2xl font-semibold text-slate-900">{module.title}</h2>
                <p className="mt-3 text-slate-600">{module.description}</p>
                <Link
                  to={module.to}
                  className="mt-6 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 via-sky-500 to-cyan-400 px-5 py-2.5 text-sm font-semibold text-slate-900 shadow-md hover:shadow-lg"
                >
                  {module.cta}
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ModuleGuide;
